import type { URLSearchParamsInit } from 'react-router';
import { createSearchParams } from 'react-router';

// View keys are scoped to a single project. Carrying them across a project
// switch produces filters for views that don't exist in the target project,
// which the backend rejects.
const projectScopedParams = ['selected-view', 'view'];

/**
 * Removes search params that reference project-scoped entities so they don't
 * leak across a project switch.
 * @param searchParams anything that can be passed to URLSearchParams constructor
 * @returns sanitized search params, or undefined if none were provided
 */
export function withoutProjectScopedSearchParams(searchParams?: URLSearchParamsInit) {
  if (!searchParams) {
    return searchParams;
  }

  const nextSearchParams = createSearchParams(searchParams);
  for (const name of projectScopedParams) {
    nextSearchParams.delete(name);
  }
  return nextSearchParams;
}
